module.exports = __webpack_public_path__ + "images/corners/Charis.8b2042fe07a435b82749602bf431c680.jpg";